import { OktaAuth } from "@okta/okta-auth-js";

const OKTA_CONFIG_STORAGE_KEY = "okta_pending_config";

export const persistOktaConfig = (issuer, clientId) => {
    sessionStorage.setItem(OKTA_CONFIG_STORAGE_KEY, JSON.stringify({ issuer, clientId }));
};

export const readOktaConfig = () => {
    const raw = sessionStorage.getItem(OKTA_CONFIG_STORAGE_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const clearOktaConfig = () => {
    sessionStorage.removeItem(OKTA_CONFIG_STORAGE_KEY);
};

export const buildOktaAuthClient = ({ issuer, clientId }) => new OktaAuth({
    issuer,
    clientId,
    redirectUri: window.location.origin,
    scopes: ["openid", "email"],
    pkce: true,
    responseType: ["code"]
});
